import { createActions, createReducer } from 'reduxsauce';

// Action Types and Creators
export const { Types, Creators } = createActions({
  getAffiliateBusinesses: ['params'],
  getAffiliateBusinessesRequest: [],
  getAffiliateBusinessesSuccess: ['data'],
  getAffiliateBusinessesFailure: ['error'],

  createAffiliateBusiness: ['payload'],
  createAffiliateBusinessRequest: [],
  createAffiliateBusinessSuccess: ['data'],
  createAffiliateBusinessFailure: ['error'],

  getAffiliateBusiness: ['id'],
  getAffiliateBusinessRequest: [],
  getAffiliateBusinessSuccess: ['data'],
  getAffiliateBusinessFailure: ['error'],

  updateAffiliateBusiness: ['id', 'payload'],
  updateAffiliateBusinessRequest: [],
  updateAffiliateBusinessSuccess: ['data'],
  updateAffiliateBusinessFailure: ['error'],

  deleteAffiliateBusiness: ['id'],
  deleteAffiliateBusinessRequest: [],
  deleteAffiliateBusinessSuccess: ['id'],
  deleteAffiliateBusinessFailure: ['error'],
}, { prefix: 'cb/affiliateBusiness/' });

// Initial State
const INITIAL_STATE = {
  fetching: false,
  fetched: false,
  error: null,
  data: [],
  created: null,
  updated: null,
};

// Reducers
const request = state => ({
  ...state,
  fetching: true,
  error: null,
});

const success = (state, { data }) => ({
  ...state,
  fetching: false,
  fetched: true,
  data,
});

const failure = (state, { error }) => ({
  ...state,
  fetching: false,
  fetched: false,
  error,
});

const deleteSuccess = (state, { id }) => ({
  ...state,
  fetching: false,
  fetched: true,
  data: state.data.filter(item => item.id !== id),
});

// ✅ Create only updates `created`
const createSuccess = (state, { data }) => ({
  ...state,
  fetching: false,
  fetched: true,
  created: data,
});

// ✅ Update only updates `updated`
const updateSuccess = (state, { data }) => ({
  ...state,
  fetching: false,
  fetched: true,
  updated: data,
});

export const HANDLERS = {
  [Types.GET_AFFILIATE_BUSINESSES_REQUEST]: request,
  [Types.GET_AFFILIATE_BUSINESSES_SUCCESS]: success,
  [Types.GET_AFFILIATE_BUSINESSES_FAILURE]: failure,

  [Types.CREATE_AFFILIATE_BUSINESS_REQUEST]: request,
  [Types.CREATE_AFFILIATE_BUSINESS_SUCCESS]: createSuccess,
  [Types.CREATE_AFFILIATE_BUSINESS_FAILURE]: failure,

  [Types.GET_AFFILIATE_BUSINESS_REQUEST]: request,
  [Types.GET_AFFILIATE_BUSINESS_SUCCESS]: success,
  [Types.GET_AFFILIATE_BUSINESS_FAILURE]: failure,

  [Types.UPDATE_AFFILIATE_BUSINESS_REQUEST]: request,
  [Types.UPDATE_AFFILIATE_BUSINESS_SUCCESS]: updateSuccess,
  [Types.UPDATE_AFFILIATE_BUSINESS_FAILURE]: failure,

  [Types.DELETE_AFFILIATE_BUSINESS_REQUEST]: request,
  [Types.DELETE_AFFILIATE_BUSINESS_SUCCESS]: deleteSuccess,
  [Types.DELETE_AFFILIATE_BUSINESS_FAILURE]: failure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
export { Types as types, Creators as actions };
